import { z } from 'zod';
/**
 *
 * Note: if there's an overlapping error for a particular field this is the order in which they'll be displayed
 * form level
 * section level
 * field level
 * base level: same level as "field", but uses built int zod validations
 */
// eslint-disable-next-line
export const sectionOConsistency = ({ input, ctx, version, isSection, field }) => {
    if (field === 'o0110') {
        const payload = input;
        // O-consistency-6030 (a) If O0110A1A=[0], then all active items from O0110A2A through O0110A10A must equal [0].
        if (!payload?.o0110CancerTreatment?.includes('A1') &&
            ['A2', 'A3', 'A10'].some((item) => payload?.o0110CancerTreatment?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6030 (a) If O0110A1 is NOT checked, then all items from O0110A2 through O0110A10 must also NOT be checked.`,
                path: ['o0110CancerTreatment'],
            });
        }
        // O-consistency-6030 (b) If O0110A1A=[1], then at least one active item from O0110A2A through O0110A10A must equal [1], and the remaining items must equal [0,1].
        if (payload?.o0110CancerTreatment?.includes('A1') &&
            !['A2', 'A3', 'A10'].some((item) => payload?.o0110CancerTreatment?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6030 (b) If O0110A1 is checked, then at least one item from O0110A2 through O0110A10 must also be checked.`,
                path: ['o0110CancerTreatment'],
            });
        }
        // O-consistency-6040 (a) If O0110C1A=[0], then all active items from O0110C2A through O0110C4A must equal [0].
        if (!payload?.o0110Respiration?.includes('C1') && ['C2', 'C3', 'C4'].some((item) => payload?.o0110Respiration?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6040 (a) If O0110C1 is NOT checked, then all items from O0110C2 through O0110C4 must also NOT be checked.`,
                path: ['o0110Respiration'],
            });
        }
        // O-consistency-6040 (b) If O0110C1A=[1], then at least one active item from O0110C2A through O0110C4A must equal [1], and the remaining items must equal [0,1].
        if (payload?.o0110Respiration?.includes('C1') && !['C2', 'C3', 'C4'].some((item) => payload?.o0110Respiration?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6040 (b) If O0110C1 is checked, then at least one item from O0110C2 through O0110C4 must also be checked.`,
                path: ['o0110Respiration'],
            });
        }
        // O-consistency-6050 (a) If O0110D1A=[0], then the following items must equal [0]: O0110D2A, O0110D3A.
        if (!payload?.o0110Respiration?.includes('D1') && ['D2', 'D3'].some((item) => payload?.o0110Respiration?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6050 (a) If O0110D1 is NOT checked, then O0110D2 through O0110D3 must also NOT be checked.`,
                path: ['o0110Respiration'],
            });
        }
        // O-consistency-6050 (b) If O0110D1A=[1], then at least one of the following items must equal [1], and the remaining items must equal [0,1]: O0110D2A, O0110D3A.
        if (payload?.o0110Respiration?.includes('D1') && !['D2', 'D3'].some((item) => payload?.o0110Respiration?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6050 (b) If O0110D1 is checked, then at least one item from O0110D2 and O0110D3 must also be checked.`,
                path: ['o0110Respiration'],
            });
        }
        // O-consistency-6060 (a) If O0110G1A=[0], then the following items must equal [0]: O0110G2A, O0110G3A.
        if (!payload?.o0110Respiration?.includes('G1') && ['G2', 'G3'].some((item) => payload?.o0110Respiration?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6060 (a) If O0110G1 is NOT checked, then O0110G2 through O0110G3 must also NOT be checked.`,
                path: ['o0110Respiration'],
            });
        }
        // O-consistency-6060 (b) If O0110G1A=[1], then at least one of the following items must equal [1], and the remaining items must equal [0,1]: O0110G2A, O0110G3A.
        if (payload?.o0110Respiration?.includes('G1') && !['G2', 'G3'].some((item) => payload?.o0110Respiration?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6060 (b) If O0110G1 is checked, then at least one item from O0110G2 and O0110G3 must also be checked.`,
                path: ['o0110Respiration'],
            });
        }
        // O-consistency-6070
        // (a) If O0110H1A=[0], then all active items from O0110H2A through O0110H10A must equal [0].
        if (!payload?.o0110Other?.includes('H1') && ['H2', 'H3', 'H4', 'H10'].some((item) => payload?.o0110Other?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6070 (a) If O0110H1 is NOT checked, then all items from O0110H2 through O0110H10 must also NOT be checked.`,
                path: ['o0110Other'],
            });
        }
        // (b) If O0110H1A=[1], then at least one of the active items from O0110H2A through O0110H10A must equal [1], and the remaining items must equal [0,1].
        if (payload?.o0110Other?.includes('H1') && !['H2', 'H3', 'H4', 'H10'].some((item) => payload?.o0110Other?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6070 (b) If O0110H1 is checked, then at least one item from O0110H2 through O0110H10 must also be checked.`,
                path: ['o0110Other'],
            });
        }
        // O-consistency-6080
        // (a) If O0110J1A=[0], then the following items must equal [0]: O0110J2A, O0110J3A.
        if (!payload?.o0110Other?.includes('J1') && ['J2', 'J3'].some((item) => payload?.o0110Other?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6080 (a) If O0110J1 is NOT checked, then O0110J2 through O0110J3 must also NOT be checked.`,
                path: ['o0110Other'],
            });
        }
        // (b) If O0110J1A=[1], then at least one of the following items must equal [1], and the remaining items must equal [0,1]: O0110J2A, O0110J3A.
        if (payload?.o0110Other?.includes('J1') && !['J2', 'J3'].some((item) => payload?.o0110Other?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6080 (b) If O0110J1 is checked, then at least one item from O0110J2 and O0110J3 must also be checked.`,
                path: ['o0110Other'],
            });
        }
        // O-consistency-6090
        // (a) If O0110O1A=[0], then all active items from O0110O2A through O0110O4A must equal [0].
        if (!payload?.o0110Other?.includes('O1') && ['O2', 'O3', 'O4'].some((item) => payload?.o0110Other?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6090 (a) If O0110O1 is NOT checked, then all items from O0110O2 through O0110O4 must also NOT be checked.`,
                path: ['o0110Other'],
            });
        }
        // (b) If O0110O1A=[1], then at least one item from O0110O2A through O0110O4A must equal [1], and the remaining items must equal [0,1].
        if (payload?.o0110Other?.includes('O1') && !['O2', 'O3', 'O4'].some((item) => payload?.o0110Other?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6090 (b) If O0110O1 is checked, then at least one item from O0110O2 through O0110O4 must also be checked.`,
                path: ['o0110Other'],
            });
        }
        //  O-consistency-6180 (a) If O0110Z1C=[1], then the following items must equal [0]: O0110A1C, O0110B1C, O0110C1C, O0110D1C, O0110E1C, O0110F1C, O0110G1C, O0110H1C, O0110I1C, O0110J1C, O0110O1C.
        if (payload?.o0110None?.includes('Z1') &&
            (['A1', 'B1'].some((item) => payload?.o0110CancerTreatment?.includes(item)) ||
                ['C1', 'D1', 'E1', 'F1', 'G1'].some((item) => payload?.o0110Respiration?.includes(item)) ||
                ['H1', 'I1', 'J1', 'O1'].some((item) => payload?.o0110Other?.includes(item)))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6180 (a) If O0110Z1 is checked, then all items from O0110A1 through O0110O1 must NOT be checked.`,
                path: ['o0110None'],
            });
        }
        //  O-consistency-6180 (b) If O0110Z1C=[0], then at least one of the following items must equal [1], and the remaining items must equal [0,1]: O0110A1C, O0110B1C, O0110C1C, O0110D1C, O0110E1C, O0110F1C, O0110G1C, O0110H1C, O0110I1C, O0110J1C, O0110O1C .
        if (!payload?.o0110None?.includes('Z1') &&
            !['A1', 'B1'].some((item) => payload?.o0110CancerTreatment?.includes(item)) &&
            !['C1', 'D1', 'E1', 'F1', 'G1'].some((item) => payload?.o0110Respiration?.includes(item)) &&
            !['H1', 'I1', 'J1', 'O1'].some((item) => payload?.o0110Other?.includes(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-6180 (a) If O0110Z1 is NOT checked, then at least one item from O0110A1 through O0110O1 must be checked.`,
                path: ['o0110None'],
            });
        }
    }
};
// O-consistency-6180
// (a) If O0110A1A=[0], then all active items from O0110A2A through O0110A10A must equal [0].
// (b) If O0110A1A=[1], then at least one active item from O0110A2A through O0110A10A must equal [1], and the remaining items must equal [0,1].
// (c) If O0110A1A=[-], then all active items from O0110A2A through O0110A10A must equal [-].
// O-consistency-6110
// (a) If O0110A1C=[0], then all active items from O0110A2C through O0110A10C must equal [0].
// (b) If O0110A1C=[1], then at least one active item from O0110A2C through O0110A10C must equal [1], and the remaining items must equal [0,1].
// (c) If O0110A1C=[-], then all active items from O0110A2C through O0110A10C must equal [-].
// O-consistency-6100
// (a) If O0110Z1A=[1], then the following items must equal [0]: O0110A1A, O0110B1A, O0110C1A, O0110D1A, O0110E1A, O0110F1A, O0110G1A, O0110H1A, O0110I1A, O0110J1A, O0110O1A.
// (b) If O0110Z1A=[0], then at least one of the following items must equal [1], and all remaining items must equal [0,1]: O0110A1A, O0110B1A, O0110C1A, O0110D1A, O0110E1A, O0110F1A, O0110G1A, O0110H1A, O0110I1A, O0110J1A, O0110O1A.
// (c) If O0110Z1A=[-], then the following items must equal [-]: O0110A1A, O0110B1A, O0110C1A, O0110D1A, O0110E1A, O0110F1A, O0110G1A, O0110H1A, O0110I1A, O0110J1A, O0110O1A.
// O-consistency-6180
// (a) If O0110Z1C=[1], then the following items must equal [0]: O0110A1C, O0110B1C, O0110C1C, O0110D1C, O0110E1C, O0110F1C, O0110G1C, O0110H1C, O0110I1C, O0110J1C, O0110O1C.
// (b) If O0110Z1C=[0], then at least one of the following items must equal [1], and the remaining items must equal [0,1]: O0110A1C, O0110B1C, O0110C1C, O0110D1C, O0110E1C, O0110F1C, O0110G1C, O0110H1C, O0110I1C, O0110J1C, O0110O1C .
// (c) If O0110Z1C=[-], then the following items must equal [-]: O0110A1C, O0110B1C, O0110C1C, O0110D1C, O0110E1C, O0110F1C, O0110G1C, O0110H1C, O0110I1C, O0110J1C and O0110O1C.
// O-consistency-6040
// (a) If O0110C1A=[0], then all active items from O0110C2A through O0110C4A must equal [0].
// (b) If O0110C1A=[1], then at least one active item from O0110C2A through O0110C4A must equal [1], and the remaining items must equal [0,1].
// (c) If O0110C1A=[-], then all active items from O0110C2A through O0110C4A must equal [-].
// O-consistency-6120
// (a) If O0110C1C=[0], then all active items from O0110C2C through O0110C4C must equal [0].
// (b) If O0110C1C=[1], then at least one active item from O0110C2C through O0110C4C must equal [1], and the remaining items must equal [0,1].
// (c) If O0110C1C=[-], then all active items from O0110C2C through O0110C4C must equal [-].
// O-consistency-6050
// (a) If O0110D1A=[0], then the following items must equal [0]: O0110D2A, O0110D3A.
// (b) If O0110D1A=[1], then at least one of the following items must equal [1], and the remaining items must equal [0,1]: O0110D2A, O0110D3A.
// (c) If O0110D1A=[-], then the following items must equal [-]: O0110D2A, O0110D3A.
// O-consistency-6130
// (a) If O0110D1C=[0], then the following items must equal [0]: O0110D2C, O0110D3C.
// (b) If O0110D1C=[1], then at least one of the following items must equal [1], and the remaining items must equal [0,1]: O0110D2C, O0110D3C.
// (c) If O0110D1C=[-], then the following items must equal [-]: O0110D2C, O0110D3C.
// O-consistency-6060
// (a) If O0110G1A=[0], then the following items must equal [0]: O0110G2A, O0110G3A.
// (b) If O0110G1A=[1], then at least one of the following items must equal [1], and the remaining items must equal [0,1]: O0110G2A, O0110G3A.
// (c) If O0110G1A=[-], then the following items must equal [-]: O0110G2A, O0110G3A.
// O-consistency-6140
// (a) If O0110G1C=[0], then the following items must equal [0]: O0110G2C, O0110G3C.
// (b) If O0110G1C=[1], then at least one of the following items must equal [1], and the remaining items must equal [0,1]: O0110G2C, O0110G3C.
// (c) If O0110G1C=[-], then the following items must equal [-]: O0110G2C, O0110G3C.
// O-consistency-6070
// (a) If O0110H1A=[0], then all active items from O0110H2A through O0110H10A must equal [0].
// (b) If O0110H1A=[1], then at least one of the active items from O0110H2A through O0110H10A must equal [1], and the remaining items must equal [0,1].
// (c) If O0110H1A=[-], then all active items from O0110H2A through O0110H10A must equal [-].
// O-consistency-6150
// (a) If O0110H1C=[0], then all active items from O0110H2C through O0110H10C must equal [0].
// (b) If O0110H1C=[1], then at least one active item from O0110H2C through O0110H10C must equal [1], and the remaining items must equal [0,1].
// (c) If O0110H1C=[-], then all active items from O0110H2C through O0110H10C must equal [-].
// O-consistency-6080
// (a) If O0110J1A=[0], then the following items must equal [0]: O0110J2A, O0110J3A.
// (b) If O0110J1A=[1], then at least one of the following items must equal [1], and the remaining items must equal [0,1]: O0110J2A, O0110J3A.
// (c) If O0110J1A=[-], then the following items must equal [-]: O0110J2A, O0110J3A.
// O-consistency-6160
// (a) If O0110J1C=[0], then the following items must equal [0]: O0110J2C, O0110J3C.
// (b) If O0110J1C=[1], then at least one of the following items must equal [1], and the remaining items must equal [0,1]: O0110J2C, O0110J3C.
// (c) If O0110J1C=[-], then the following items must equal [-]: O0110J2C, O0110J3C.
// O-consistency-6090
// (a) If O0110O1A=[0], then all active items from O0110O2A through O0110O4A must equal [0].
// (b) If O0110O1A=[1], then at least one item from O0110O2A through O0110O4A must equal [1], and the remaining items must equal [0,1].
// (c) If O0110O1A=[-], then all active items from O0110O2A through O0110O4A must equal [-].
// O-consistency-6170
// (a) If O0110O1C=[0], then all active items from O0110O2C through O0110O4C must equal [0].
// (b) If O0110O1C=[1], then at least one active item from O0110O2C through O0110C4C must equal [1], and the remaining items must equal [0,1].
// (c) If O0110O1C=[-], then all active items from O0110O2C through O0110O4C must equal [-].
